import React, { useState } from 'react';
import { HeroBannerProContentfulModel } from 'src/api/models/HeroBannerPro';
import OverlayVideo from 'src/elements/video/overlay.video';
import BannerPro from 'src/organisms/banners/Banner.pro';

export default function getDynamicHeroBannerPro(heroBannerProps: HeroBannerProContentfulModel): React.ReactNode {
  const [ videoModalIsOpened, setVideoModalIsOpened ] = useState(false);

  const videoButton = heroBannerProps.buttons.find(button => !!button.video)
  return (
    <>
      <BannerPro
        {...{
          title: heroBannerProps.title,
          titleColor: heroBannerProps.titleColor,
          description: heroBannerProps.description,
          removeConfetti: true,
          textPosition: 'left',
          theme: 'pro',
          actionLink: {
            url: heroBannerProps.buttons[ 0 ].url,
            text: heroBannerProps.buttons[ 0 ].text,
            caption: heroBannerProps.buttons[ 0 ].helpText || null
          },
          actionButton: {
            text: heroBannerProps.buttons[ 1 ]?.text,
            onClick: () => setVideoModalIsOpened(true)
          },
          videoUrl: heroBannerProps.media?.file?.url,
          image: heroBannerProps.media?.gatsbyImageData,
          isVideo: heroBannerProps.media?.file?.contentType === 'video/mp4',
        }}
      />
      {
        videoButton && (
          <OverlayVideo
            overlayVisible={videoModalIsOpened}
            setOverlayVisible={setVideoModalIsOpened}
            src={videoButton.video.file.url}
          />
        )
      }
    </>
  )
}
